export enum singleEntryContentType {
    SiteWidePromoBanner = 'siteWidePromoBanner',
}
